import { render, staticRenderFns } from "./third-sdk.vue?vue&type=template&id=575d3142&scoped=true&"
import script from "./third-sdk.vue?vue&type=script&lang=js&"
export * from "./third-sdk.vue?vue&type=script&lang=js&"
import style0 from "./third-sdk.vue?vue&type=style&index=0&id=575d3142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d3142",
  null
  
)

export default component.exports